export function isvalidUsername(str) {
  const validMap = ['admin', 'editor'];
  return validMap.indexOf(str.trim()) >= 0;
}

/* 合法uri */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母 */
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * validate email
 * Mail format must be like something@something.something
 * @param email
 * @returns {boolean}
 */
export function isValidEmail(email) {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function isValidPhone(phone) {
  if (phone.length !== 10) {
    return false;
  } else if (!phone.startsWith('69')) {
    return false;
  } else if (isNaN(phone)) {
    return false;
  } else {
    return true;
  }
}
export function isValidPhoneWithCode(phone, countryCode) {
  if (phone.length === 0) {
    return false;
  } else if (isNaN(phone)) {
    return false;
  } else {
    if (countryCode === 30) {
      if (phone.length !== 10) {
        return false;
      } else if (!phone.startsWith('69')) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

/**
 * validate password
 * Password must contain: min 8 chars, min 1 uppercase, min 1 digit, min one special char
 * @param password
 * @returns {boolean}
 */
export function isValidPassword(password) {
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()~#_+={}|:;<>,.\-^])[A-Za-z\d@$!%*?&()~#_+={}|:;<>,.\-^]{8,}$/;
  return re.test(password);
}



// WEBPACK FOOTER //
// ./src/utils/validate.js